"use client";

import Button from "@/components/ui/button/Button";
import SearchableSelect from "@/components/ui/SearchableSelect";
import Input from "@/components/form/input/InputField";
import Label from "@/components/form/Label";
import TextArea from "@/components/form/input/TextArea";
import { rmcClient } from "@/lib/rmcClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import toast from "react-hot-toast";

export default function ReceiptForm({ onDone }) {
  const qc = useQueryClient();
  const [partyId, setPartyId] = React.useState(null);
  const [date, setDate] = React.useState(new Date().toISOString().slice(0, 10));
  const [amount, setAmount] = React.useState("");
  const [remark, setRemark] = React.useState("");

  const { data: parties = [] } = useQuery({
    queryKey: ["salesParties"],
    queryFn: async () => (await rmcClient.listSalesParties()).data,
  });
  const { data: receiptNumber } = useQuery({
    queryKey: ["receipt-number"],
    queryFn: async () => (await rmcClient.getReceiptNumber()).data,
  });

  const save = useMutation({
    mutationFn: () =>
      rmcClient.createReceipt({
        party_id: partyId,
        date,
        amount,
        remark,
      }),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ["receipts"] });
      qc.invalidateQueries({ queryKey: ["ledger"] });
      toast.success(`${res?.receipt_no || "Receipt"} created`);
      setAmount("");
      setRemark("");
      onDone?.();
    },
    onError: () => toast.error("Failed"),
  });

  return (
    <div className="space-y-3">
      <div>
        <Label>Receipt No</Label>
        <Input
          value={receiptNumber?.next_receipt_no || "Loading..."}
          disabled
          className="mt-1 bg-gray-900/60 text-gray-200"
        />
      </div>
      <div>
        <Label>Date</Label>
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1" />
      </div>
      <SearchableSelect
        label="Party Name"
        value={partyId}
        onChange={setPartyId}
        options={parties}
        placeholder="Select party..."
        overlayZClass="z-[100002]"
        menuZClass="z-[100003]"
      />
      <div>
        <Label>Amount (₹)</Label>
        <Input
          type="number"
          step="0.01"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="mt-1"
        />
      </div>
      <div>
        <Label>Remark</Label>
        <TextArea
          value={remark}
          onChange={setRemark}
          rows={2}
          className="mt-1 !text-xs rounded-md border-gray-800 !bg-gray-950 !text-white"
        />
      </div>
      <Button
        size="sm"
        disabled={!partyId || !amount || Number(amount) <= 0 || save.isPending}
        onClick={() => save.mutate()}
      >
        {save.isPending ? "Saving…" : "Save Receipt"}
      </Button>
    </div>
  );
}
